import React, { useState, useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import g34 from "../assets/images/bg34-1.png";
import logo from "../assets/images/tiger2.png";
import qrcode from "../assets/images/qrcode.svg";
import shap from "../assets/images/shape1.png";
import "../assets/css/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import Privacypolicy from "../pages/Policy/Privacypolicy";
import TermsAndCondition from "../pages/Policy/TermsAndCondition";
import { useAuth } from "../context/AuthContext";
import config from "../config";
import axios from "axios";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";

const Register = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        otp_code: ""
    });

    const [errors, setErrors] = useState({
        first_name: "",
        last_name: "",
        email: "",
        password: ""
    });

    const [otpSent, setOtpSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(false);

    // 🔁 resend timer
    const [resendVisible, setResendVisible] = useState(false);
    const [timer, setTimer] = useState(30);

    const [visible, setVisible] = useState(false);
    const [visible2, setVisible2] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors((prev) => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;

        setForm((prev) => ({
            ...prev,
            password: value
        }));

        if (errors.password) {
            setErrors((prev) => ({
                ...prev,
                password: ""
            }));
        }
    };

    const validateRegistrationForm = () => {
        const newErrors = {};

        const firstName = form.first_name.trim();
        const lastName = form.last_name.trim();
        const email = form.email.trim();

        const nameRegex = /^[A-Za-z\\s'-]+$/;
        const emailRegex = /^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/;

        if (!firstName) {
            newErrors.first_name = "First name is required";
        } else if (firstName.length < 2) {
            newErrors.first_name = "First name must be at least 2 characters";
        } else if (firstName.length > 50) {
            newErrors.first_name = "First name cannot exceed 50 characters";
        } else if (!nameRegex.test(firstName)) {
            newErrors.first_name =
                "First name can only contain letters, spaces, hyphens, and apostrophes";
        }

        if (!lastName) {
            newErrors.last_name = "Last name is required";
        } else if (lastName.length < 2) {
            newErrors.last_name = "Last name must be at least 2 characters";
        } else if (lastName.length > 50) {
            newErrors.last_name = "Last name cannot exceed 50 characters";
        } else if (!nameRegex.test(lastName)) {
            newErrors.last_name =
                "Last name can only contain letters, spaces, hyphens, and apostrophes";
        }

        if (!form.password) {
            newErrors.password = "Password is required";
        } else if (form.password.length < 8) {
            newErrors.password = "Password must be at least 8 characters";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ⏱️ 30 sec resend logic
    useEffect(() => {
        if (!otpSent) return;

        setTimer(30);
        setResendVisible(false);

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setResendVisible(true);
                    return 0;
                }

                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [otpSent]);

    // 📤 REQUEST OTP
    const requestOtp = async () => {
        if (!validateRegistrationForm()) {
            toast.error("Please correct the highlighted fields");
            return;
        }

        if (!checked) {
            toast.warning("Please accept Terms & Privacy Policy");
            return;
        }

        try {
            setLoading(true);

            const { data } = await axios.post(
                `${config.API_BASE_URL}/cauthRoutes/send-otp`,
                {
                    email: form.email.trim().toLowerCase(),
                    otp_type: "CustomerReg"
                }
            );

            setOtpSent(true);
            toast.success(data.message);
        } catch (err) {
            toast.error(
                err.response?.data?.message || "Failed to send OTP"
            );
        } finally {
            setLoading(false);
        }
    };

    // 📥 REGISTER + AUTO LOGIN
    const submitRegistration = async () => {
        if (!validateRegistrationForm()) {
            toast.error("Please correct the highlighted fields");
            return;
        }

        if (!form.otp_code.trim()) {
            toast.warning("OTP is required");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                ...form,
                first_name: form.first_name.trim(),
                last_name: form.last_name.trim(),
                email: form.email.trim().toLowerCase(),
                otp_code: form.otp_code.trim()
            };

            const { data } = await axios.post(
                `${config.API_BASE_URL}/cauthRoutes/customer_register`,
                payload
            );

            login({
                userId: data.customerId,
                username: data.name,
                imgUrl: null
            });

            toast.success(data.message);

            navigate("/home", { replace: true });
        } catch (err) {
            toast.error(
                err.response?.data?.message || "Registration failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title>Register | Shaadi Material</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <section className="useraccountDiv">
                <div className="fxt-shape">
                    <div className="fxt-transformX-L-50 fxt-transition-delay-1">
                        <img src={shap} alt="shape" />
                    </div>
                </div>

                <Container>
                    <Row className="mx-0 breadcrumb_part align-items-center">
                        <Col lg={8}>
                            <div className="fxt-column-wrap justify-content-center">
                                {/*
                                <div className="fxt-animated-img">
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-10">
                                        <img src={g34} alt="productimg" />
                                    </div>
                                </div>
                                */}

                                <div>
                                    <div className="fxt-transformX-L-50 fxt-transition-delay-3">
                                        <Link to="/" className="logo me-5">
                                            <img
                                                src={logo}
                                                alt="Logo"
                                                style={{ height: "150px" }}
                                            />
                                        </Link>
                                    </div>

                                    <div className="fxt-transformX-L-50 fxt-transition-delay-5">
                                        <div className="fxt-middle-content">
                                            <h1 className="fxt-main-title">
                                                Sign Up to
                                                <br />
                                                Shaadi Material
                                            </h1>

                                            <div className="fxt-switcher-description1">
                                                If you have an account You can
                                                <Link
                                                    to="/login"
                                                    className="fxt-switcher-text ms-2 fw-bold text-info"
                                                >
                                                    Sign In
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*
                                <div className="fxt-transformX-L-50 fxt-transition-delay-7">
                                    <div className="fxt-qr-code">
                                        <img
                                            src={qrcode}
                                            alt="Logo"
                                            style={{ height: "130px" }}
                                        />
                                    </div>
                                </div>
                                */}
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="prof_content user-dash">
                                <div className="d-flex flex-column gap-2 mb-4">
                                    <label>First Name</label>

                                    <InputText
                                        name="first_name"
                                        value={form.first_name}
                                        onChange={handleChange}
                                        placeholder="First Name"
                                        maxLength={50}
                                        className={errors.first_name ? "p-invalid" : ""}
                                        aria-invalid={Boolean(errors.first_name)}
                                    />

                                    {errors.first_name && (
                                        <small className="p-error">
                                            {errors.first_name}
                                        </small>
                                    )}
                                </div>

                                <div className="d-flex flex-column gap-2 mb-4">
                                    <label>Last Name</label>

                                    <InputText
                                        name="last_name"
                                        value={form.last_name}
                                        onChange={handleChange}
                                        placeholder="Last Name"
                                        maxLength={50}
                                        className={errors.last_name ? "p-invalid" : ""}
                                        aria-invalid={Boolean(errors.last_name)}
                                    />

                                    {errors.last_name && (
                                        <small className="p-error">
                                            {errors.last_name}
                                        </small>
                                    )}
                                </div>

                                <div className="d-flex flex-column gap-2 mb-4">
                                    <label>Email</label>

                                    <InputText
                                        name="email"
                                        value={form.email}
                                        onChange={handleChange}
                                        placeholder="Email"
                                        className={errors.email ? "p-invalid" : ""}
                                        aria-invalid={Boolean(errors.email)}
                                    />

                                    {errors.email && (
                                        <small className="p-error">
                                            {errors.email}
                                        </small>
                                    )}
                                </div>

                                <div className="d-flex flex-column gap-2 mb-2">
                                    <label>Password</label>

                                    <Password
                                        name="password"
                                        value={form.password}
                                        onChange={handlePasswordChange}
                                        toggleMask
                                        className={errors.password ? "p-invalid" : ""}
                                        inputClassName={errors.password ? "p-invalid" : ""}
                                        aria-invalid={Boolean(errors.password)}
                                    />

                                    {errors.password && (
                                        <small className="p-error">
                                            {errors.password}
                                        </small>
                                    )}
                                </div>

                                <div className="d-flex flex-column gap-2 mb-2">
                                    {otpSent && (
                                        <InputText
                                            name="otp_code"
                                            value={form.otp_code}
                                            onChange={handleChange}
                                            placeholder="Enter OTP"
                                        />
                                    )}
                                </div>

                                <div className="d-block my-3">
                                    <label
                                        htmlFor="ingredient1"
                                        className="d-flex align-items-center gap-2 mb-4"
                                    >
                                        <Checkbox
                                            inputId="ingredient1"
                                            checked={checked}
                                            onChange={(e) => setChecked(e.checked)}
                                        />

                                        <span>
                                            I agree with the{" "}
                                            <Link
                                                className="text-info"
                                                onClick={() => setVisible(true)}
                                            >
                                                Terms
                                            </Link>{" "}
                                            and{" "}
                                            <Link
                                                onClick={() => setVisible2(true)}
                                                className="text-info"
                                            >
                                                Privacy Policy
                                            </Link>
                                        </span>
                                    </label>
                                </div>

                                {!otpSent ? (
                                    <Button
                                        label="Request OTP"
                                        className="py-2 w-100 d-block mt-4 custbuttonpink"
                                        style={{ fontSize: "22px" }}
                                        onClick={requestOtp}
                                        loading={loading}
                                    />
                                ) : (
                                    <>
                                        <Button
                                            label="Sign Up"
                                            className="py-2 w-100 d-block mt-4 custbuttonpink"
                                            style={{ fontSize: "22px" }}
                                            onClick={submitRegistration}
                                            loading={loading}
                                        />

                                        {!resendVisible ? (
                                            <p className="text-muted mt-2">
                                                Resend OTP in {timer}s
                                            </p>
                                        ) : (
                                            <Button
                                                text
                                                label="Resend OTP"
                                                onClick={requestOtp}
                                                disabled={loading}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Dialog
                visible={visible}
                style={{ width: "50vw", height: "70vh" }}
                onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                }}
            >
                <TermsAndCondition />
            </Dialog>

            <Dialog
                visible={visible2}
                style={{ width: "50vw", height: "70vh" }}
                onHide={() => {
                    if (!visible2) return;
                    setVisible2(false);
                }}
            >
                <Privacypolicy />
            </Dialog>
        </>
    );
};

export default Register;